import CurrentActivity from "./current-activity";

const Offers: React.FC = () => {
  return (
    <div>
      <div className="mt-1">
        <h3 className="text-xl font-semibold text-[#111827]">
          Activity Calendar
        </h3>
        <CurrentActivity />
      </div>
    </div>
  );
};

export default Offers;
